import React, { useEffect, useState } from 'react'
import { dropDownSelectionStyles, getValueFromResource } from '../../common/timeLiveFunction';
import { KTSVG } from '../../_metronic/helpers';
import DatePicker from "react-datepicker";
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { CurrentCultureDateFormat } from '../../common/UiUtilities';
import moment from 'moment';
import Select from 'react-select';
import fetchIntegrationAPI from '../../common/fetchIntegrationAPI';
import { addEventCalendar, addEventInGoogle, addEventInOutlook, GetAccountEmployeeTimeEntryCustomFields, GetAccountWorkingDayType, gettimesheetData, updateCustomFieldFalg, UpdateEventCalendar, updateEventFalg } from './CalendarSlice';
import { ShowToast } from '../../common/Toastr';
import { GetCalendarEventsForNotification } from '../../common/GlobalSlice';
import AddTimeEntry from './AddTimeEntry';

interface AddEventModalProps {
    modelRef?: any;
    t: any;
    oncloseModal: () => void;
    clickedDate?: any;
    selectedEvent?: any;
    presetStartTime: string;
    presetEndTime: string;
    showTimesheet: boolean;
    IsAdd?:boolean;
}

interface TimezoneOption {
    value: number;
    label: string;
    offset?: number;
}

const UpdateInternalEvent: React.FC<AddEventModalProps> = ({
    t,
    oncloseModal,
    clickedDate = new Date(),
    selectedEvent,
    presetStartTime,
    presetEndTime,
    showTimesheet,
    IsAdd
}) => {
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector((state) => state.expensetype);
    const { calendarStartDay, maxMenuHeight, customFieldInsertionFormat,CurrentCultureDateFormat, cultureInfoName, timeZoneId } = useAppSelector((state) => state.globalState);
    const { googleConnected, outlookConnected } = useAppSelector((state) => state.calendar);

    const [eventDate, setEventDate] = useState<Date>(clickedDate);
    const [eventEndDate, setEventEndDate] = useState<Date>(clickedDate);
    const [eventName, setEventName] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [totalTime, setTotalTime] = useState('');
    const [description, setDescription] = useState('');
    const [selectedReminderTime, setSelectedReminderTime] = useState<number | undefined>();
    const [reminderOptions, setReminderOptions] = useState<{ value: number; label: string }[]>([]);
    const [timezoneOptions, setTimezoneOptions] = useState<TimezoneOption[]>([]);
    const [selectedTimezone, setSelectedTimezone] = useState<number | undefined>()
    const [timezoneEndOptions, setTimezoneEndOptions] = useState<TimezoneOption[]>([]);
    const [selectedEndTimezone, setSelectedEndTimezone] = useState<number | undefined>()
    const [activeTab, setActiveTab] = useState<'event' | 'timeentry'>(IsAdd ? 'event' : 'timeentry');
    const [showTimexone, setShowTimezone] = useState(false);
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    const AccountId = localStorage.getItem('accountId');
    const updateInternalEvent = selectedEvent?.extendedProps?.type === 'internal';
    const currentDate = moment().format('YYYY-MM-DD')
    //timezone
    // const parseGMTOffset = (timezoneString: string): number => {
    //     let match = timezoneString.match(/GMT([+-]?)(\d{1,2})\.(\d{2})/);
    //     if (match) {
    //         const sign = match[1] === '-' ? -1 : 1;
    //         const hours = parseInt(match[2]);
    //         const minutes = parseInt(match[3]);
    //         return sign * (hours * 60 + minutes);
    //     }

    //     match = timezoneString.match(/GMT([+-]?)(\d{1,2})/);
    //     if (match) {
    //         const sign = match[1] === '-' ? -1 : 1;
    //         const hours = parseInt(match[2]);
    //         return sign * (hours * 60);
    //     }

    //     return 0;
    // };
    //timezone
    // const convertTimeBetweenTimezones = (
    //     time: string,
    //     date: Date,
    //     fromTimezoneId: number | undefined,
    //     toTimezoneId: number | undefined
    // ): string => {
    //     if (!fromTimezoneId || !toTimezoneId || fromTimezoneId === toTimezoneId) {
    //         return time;
    //     }

    //     const fromTimezone = timezoneOptions.find(tz => tz.value === fromTimezoneId);
    //     const toTimezone = timezoneOptions.find(tz => tz.value === toTimezoneId);

    //     if (!fromTimezone || !toTimezone) {
    //         return time;
    //     }

    //     const [hours, minutes] = time.split(':').map(Number);
    //     const baseDateTime = moment(date).set({ hour: hours, minute: minutes, second: 0 });
    //     const utcTime = baseDateTime.subtract(fromTimezone.offset || 0, 'minutes');
    //     const targetTime = utcTime.add(toTimezone.offset || 0, 'minutes');

    //     return targetTime.format('HH:mm');
    // };

    const calculateTotalTime = (startDate: Date, endDate: Date, start: string, end: string) => {
        if (!start || !end) return '';

        const [sh, sm] = start.split(':').map(Number);
        const [eh, em] = end.split(':').map(Number);
        let startDateTime = moment(startDate).set({ hour: sh, minute: sm, second: 0 });
        let endDateTime = moment(endDate).set({ hour: eh, minute: em, second: 0 });

        if (selectedTimezone && showTimexone) {
            const startTimezoneOffset = timezoneOptions.find(tz => tz.value === selectedTimezone)?.offset || 0;
            startDateTime = startDateTime.subtract(startTimezoneOffset, 'minutes');
        }
        //timezone
        // if (selectedEndTimezone && showTimexone) {
        //     const endTimezoneOffset = timezoneEndOptions.find(tz => tz.value === selectedEndTimezone)?.offset || 0;
        //     endDateTime = endDateTime.subtract(endTimezoneOffset, 'minutes');
        // }
        //timezone
        // if (endDateTime.isBefore(startDateTime)) {
        //     endDateTime = endDateTime.add(1, 'day');
        // }

        const diffMs = endDateTime.diff(startDateTime);
        const hrs = String(Math.floor(diffMs / 3600000)).padStart(2, '0');
        const mins = String(Math.floor((diffMs % 3600000) / 60000)).padStart(2, '0');
        return `${hrs}:${mins}:00`;
    };

    const calculateAppropriateDate = (startDate: Date, currentEndDate: Date, start: string, end: string): Date => {
        if (!start || !end) return currentEndDate;

        const [sh, sm] = start.split(':').map(Number);
        const [eh, em] = end.split(':').map(Number);

        const startDateTime = moment(startDate).set({ hour: sh, minute: sm, second: 0 });
        const endDateTime = moment(startDate).set({ hour: eh, minute: em, second: 0 });
        if (endDateTime.isBefore(startDateTime)) {
            return moment(startDate).add(1, 'day').toDate();
        }

        return startDate;
    };

    const calculateAppropriateEndDate = (startDate: Date, start: string, end: string): Date => {
        if (!start || !end) return startDate;

        const [sh, sm] = start.split(':').map(Number);
        const [eh, em] = end.split(':').map(Number);
        const startMinutes = sh * 60 + sm;
        const endMinutes = eh * 60 + em;
        if (endMinutes <= startMinutes) {
            return moment(startDate).add(1, 'day').toDate();
        }

        return startDate;
    };

    const updateTotalTime = () => {
        setTotalTime(calculateTotalTime(eventDate, eventEndDate, startTime, endTime));
    };

    const updateEndDateBasedOnTimes = () => {
        if (startTime && endTime) {
            const newEndDate = calculateAppropriateEndDate(eventDate, startTime, endTime);
            setEventEndDate(newEndDate);
        }
    };

    useEffect(() => {
        if (!updateInternalEvent) {
            updateEndDateBasedOnTimes();
        }
    }, [eventDate, startTime, endTime]);

    useEffect(() => {
        if (!updateInternalEvent) {
            updateTotalTime();
        } else {
            updateTotalTime();
        }
    }, [eventDate, eventEndDate, startTime, endTime]);

    const getInternalEventById = async () => {
        const { id } = selectedEvent;
        if (id) {
            try {
                const response = await fetchIntegrationAPI(`api/Calendar/GetCalendarEventsByCalendarEventId/${AccountEmployeeId}/${id}`, 'GET', "", true);
                const json = await response.json();
                if (json?.StatusCode === '200' && json?.Data && json.Data.length > 0) {
                    const record = json.Data[0];
                    const { Description, EndTime, EventDate, EventName, StartTime, SystemReminderTimeId, StartTimeZoneId, EndTimeZoneId, EndDate } = record;
                    const startFormatted = moment(StartTime).format("HH:mm");
                    const endFormatted = moment(EndTime).format("HH:mm");
                    setEventName(EventName || '');
                    setDescription(Description);
                    setStartTime(startFormatted);
                    setEndTime(endFormatted);
                    setEventDate(new Date(EventDate));
                    setEventEndDate(new Date(EndDate ?? EventDate));
                    setSelectedTimezone(StartTimeZoneId);
                    setSelectedEndTimezone(EndTimeZoneId);
                    setSelectedReminderTime(SystemReminderTimeId);
                    setTotalTime(calculateTotalTime(new Date(EventDate), new Date(EndDate), startFormatted, endFormatted));
                }
            } catch (error) {
                console.log(error);
                ShowToast('Error', error, "error", "toast-top-right");
            }
        }
    }

    const getSystemReminderTimeOptions = async () => {
        try {
            const response = await fetchIntegrationAPI("api/ReminderTime", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            const options = json?.Data?.map((item: any) => ({
                value: item.SystemReminderTimeId,
                label: item.Reminder
            }));
            setReminderOptions(options);
            if (options.length > 0 && !selectedEvent) {
                setSelectedReminderTime(options[0].value);
            }
        } catch (error) {
            console.log(error);
            ShowToast('Error', error, "error", "toast-top-right");
        }
    };

    const getTimezobeOptions = async () => {
        try {
            const response = await fetchIntegrationAPI("api/Timezone", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            if (json?.Data?.length > 0) {
                const options = json?.Data?.map((item: any) => ({
                    value: item.SystemTimeZoneId,
                    label: item.SystemTimeZone,
                    // offset: parseGMTOffset(item.SystemTimeZone) //timezone
                }));
                setTimezoneOptions(options);
                setTimezoneEndOptions(options);
                if (options.length > 0 && !selectedEvent) {
                    // setSelectedTimezone(options[0].value); //timezone
                    // setSelectedEndTimezone(options[0].value); //timezone
                    setSelectedTimezone(Number(timeZoneId));
                    setSelectedEndTimezone(Number(timeZoneId));
                }
            }
        } catch (error) {
            console.log(error);
            ShowToast('Error', error, "error", "toast-top-right");
        }
    }

    const setDefaultTimes = (baseDate: Date) => {
        const start = moment(baseDate).format("HH:mm");
        const end = moment(baseDate).add(1, 'hour').format("HH:mm");
        setStartTime(start);
        setEndTime(end);
        setTotalTime(calculateTotalTime(baseDate, baseDate, start, end));
    };

    useEffect(() => {
        getTimezobeOptions();
    }, [])

    useEffect(() => {
        getSystemReminderTimeOptions();
    }, []);

    useEffect(() => {
        if (updateInternalEvent) {
            getInternalEventById();
        }
    }, [selectedEvent])

    useEffect(() => {
        if (!selectedEvent) {
            if (presetStartTime && presetEndTime) {
                setStartTime(presetStartTime);
                setEndTime(presetEndTime);
                setTotalTime(calculateTotalTime(eventDate, eventEndDate, presetStartTime, presetEndTime));
            } else {
                setDefaultTimes(new Date());
            }
            return;
        }
    }, [selectedEvent, presetStartTime, presetEndTime]);

    const handleSubmit = async () => {
        if (moment(eventDate).isSame(moment(eventEndDate), 'day') && startTime === endTime) {
            ShowToast('Error', 'Start and end date/time cannot be the same.', "error", "toast-top-right");
            return;
        }
        let startDateTime = moment(eventDate).set({
            hour: parseInt(startTime.split(':')[0]),
            minute: parseInt(startTime.split(':')[1])
        });
        let endDateTime = moment(eventEndDate).set({
            hour: parseInt(endTime.split(':')[0]),
            minute: parseInt(endTime.split(':')[1])
        });
        //timezone
        // if (showTimexone && selectedTimezone) {
        //     const startTimezoneOffset = timezoneOptions.find(tz => tz.value === selectedTimezone)?.offset || 0;
        //     startDateTime = startDateTime.subtract(startTimezoneOffset, 'minutes');
        // }
        //timezone
        // if (showTimexone && selectedEndTimezone) {
        //     const endTimezoneOffset = timezoneEndOptions.find(tz => tz.value === selectedEndTimezone)?.offset || 0;
        //     endDateTime = endDateTime.subtract(endTimezoneOffset, 'minutes');
        // }

        if (moment(eventDate).isSame(moment(eventEndDate), 'day') && endDateTime.isBefore(startDateTime)) {
            ShowToast('Invalid Event Duration', 'On the same date, end time must be later than start time.', "error", "toast-top-right");
            return;
        }
        if (moment(eventEndDate).isBefore(moment(eventDate), 'day')) {
            ShowToast('Error', 'End Date cannot be earlier than Start Date.', "error", "toast-top-right");
            return;
        }

        if (updateInternalEvent) {
            try {
                await dispatch(UpdateEventCalendar({
                    CalendarEventId: selectedEvent.id,
                    AccountId,
                    AccountEmployeeId,
                    EventName: eventName,
                    Description: description,
                    StartTime: startDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                    EndTime: endDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                    EventDate: moment(eventDate).format('YYYY-MM-DD'),
                    StartDate: moment(eventDate).format('YYYY-MM-DD'),
                    EndDate: moment(eventEndDate).format('YYYY-MM-DD'),
                    StartTimeZoneId: selectedTimezone,
                    EndTimeZoneId: selectedEndTimezone,
                    SystemReminderTimeId: selectedReminderTime,
                    SystemReminderTypeId: 2,
                })).unwrap();
                dispatch(updateEventFalg(true));
                if (moment(eventDate).format('YYYY-MM-DD') === moment(currentDate).format('YYYY-MM-DD')) {
                    dispatch(GetCalendarEventsForNotification(currentDate))
                }
            } catch (error) {
                console.error('Error updating event:', error);
                ShowToast('Error', error, "error", "toast-top-right");
            }
        } else {
            try {
                await dispatch(addEventCalendar({
                    CalendarTypeId: 1,
                    AccountId,
                    AccountEmployeeId,
                    EventName: eventName,
                    Description: description,
                    StartTime: startDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                    EndTime: endDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                    EventDate: moment(eventDate).format('YYYY-MM-DD'),
                    StartDate: moment(eventDate).format('YYYY-MM-DD'),
                    EndDate: moment(eventEndDate).format('YYYY-MM-DD'),
                    SystemReminderTimeId: selectedReminderTime,
                    ExternalReferenceId: 'Timelive',
                    SyncDirection: null,
                    CreatedByEmployeeId: AccountEmployeeId,
                    SystemReminderTypeId: 2,
                    EventLink: null,
                    StartTimeZone: !showTimexone ? null : selectedTimezone?.toString() ?? '',
                    EndTimeZone: !showTimexone ? null : selectedEndTimezone?.toString() ?? '',
                }));
                if (googleConnected?.OutBound === true) {
                    dispatch(addEventInGoogle({
                        Summary: eventName,
                        Description: description,
                        Location: 'abcs',
                        StartDateTime: startDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                        EndDateTime: endDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                        TimeZone: "Asia/Karachi"
                    }))
                }
                if (outlookConnected?.OutBound === true) {
                    dispatch(addEventInOutlook({
                        Summary: eventName,
                        Body: description,
                        Location: 'abcs',
                        StartDateTime: startDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                        EndDateTime: endDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                        TimeZone: "Pakistan Standard Time"
                    }))
                }
                dispatch(updateEventFalg(true));
                if (moment(eventDate).format('YYYY-MM-DD') === moment(currentDate).format('YYYY-MM-DD')) {
                    dispatch(GetCalendarEventsForNotification(currentDate))
                }
            } catch (error) {
                console.error('Error Adding event:', error);
                ShowToast('Error', error, "error", "toast-top-right");
            }
        }
        oncloseModal();
    };

    const handleShowTimezone = () => {
        setShowTimezone(!showTimexone)
    }

    const handleStartTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newStartTime = e.target.value;
        setStartTime(newStartTime);
        const appropriateEndDate = calculateAppropriateDate(eventDate, eventEndDate, newStartTime, endTime);
        setEventEndDate(appropriateEndDate);
    };

    const handleEndTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newEndTime = e.target.value;
        setEndTime(newEndTime);
        const appropriateEndDate = calculateAppropriateDate(eventDate, eventEndDate, startTime, newEndTime);
        setEventEndDate(appropriateEndDate);
    };

    const handleStartDateChange = (date: Date | null) => {
        const newDate = date || new Date();
        setEventDate(newDate);
        if (moment(eventEndDate).isSame(eventDate, 'day')) {
            setEventEndDate(newDate);
        }
    };

    const formatDuration = (timeString: any) => {
        if (!timeString) return "";
        const [hours, minutes, seconds] = timeString.split(":").map(Number);

        let result = "";
        result += `${hours}hr ${minutes}min`;
        return result.trim();
    };

    const getModalTitleKey = () => {
        if (updateInternalEvent) return 'Edit Event';

        switch (activeTab) {
            case 'event':
                return 'Create Event';
            case 'timeentry':
                return 'Create Time Entry';
            default:
                return IsAdd ? 'Create Event' : 'Create Time Entry';
        }
    };
    //timezone
    // const handleStartTimezoneChange = (option: any) => {
    //     if (showTimexone && selectedTimezone && option.value !== selectedTimezone) {
    //         const convertedTime = convertTimeBetweenTimezones(
    //             startTime,
    //             eventDate,
    //             selectedTimezone,
    //             option.value
    //         );
    //         setStartTime(convertedTime);
    //     }
    //     setSelectedTimezone(option.value);
    // };
    //timezone
    // const handleEndTimezoneChange = (option: any) => {
    //     if (showTimexone && selectedEndTimezone && option.value !== selectedEndTimezone) {
    //         const convertedTime = convertTimeBetweenTimezones(
    //             endTime,
    //             eventEndDate,
    //             selectedEndTimezone,
    //             option.value
    //         );
    //         setEndTime(convertedTime);
    //     }
    //     setSelectedEndTimezone(option.value);
    // }

    return (
        <div className="card-body">
            {isLoading ? (
                <div className="col-md-12 text-center">
                    <span className='spinner-border spinner-border-md'></span>
                </div>
            ) : (
                <div className="modal drawer-overlay" style={{ display: 'block' }}>
                    <div className="modal-dialog" style={{ maxWidth: '650px' }}>
                        <div className="modal-content" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                            <div className="modal-header justify-content-between" style={{ padding: '.6rem .6rem', flexShrink: 0 }}>
                                <h5 className="modal-title mainHeading">{updateInternalEvent ? getValueFromResource('Edit Event', dispatch, t) : getValueFromResource(getModalTitleKey(), dispatch, t)}</h5>

                                <div className="btn btn-icon btn-sm btn-active-secondary" onClick={oncloseModal}>
                                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                                </div>
                            </div>
                            {(!updateInternalEvent && showTimesheet) && (
                                <div className="px-4 pt-3">
                                    <ul className="nav nav-tabs nav-line-tabs mb-0 mx-3" role="tablist">
                                        {IsAdd && <li className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${activeTab === 'event' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('event')}
                                                type="button"
                                                role="tab"
                                            >
                                                {getValueFromResource('Event', dispatch, t)}
                                            </button>
                                        </li>}
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${activeTab === 'timeentry' ? 'active' : ''}`}
                                                onClick={() => {
                                                    setActiveTab('timeentry')
                                                    const currentDate = moment(eventDate).format('YYYY-MM-DD');
                                                    const endDate = moment(eventEndDate).format('YYYY-MM-DD');
                                                    const obj = { AccountEmployeeId, currentDate, endDate }
                                                    dispatch(gettimesheetData(obj))
                                                    dispatch(GetAccountEmployeeTimeEntryCustomFields())
                                                    dispatch(GetAccountWorkingDayType());
                                                    dispatch(updateCustomFieldFalg(true));
                                                }}
                                                type="button"
                                                role="tab"
                                            >
                                                {getValueFromResource('Time Entry', dispatch, t)}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}
                            {(activeTab === 'event' && IsAdd) ? (
                                <>
                                    <div className="modal-body" style={{ overflowY: 'auto', flexGrow: 1 }}>
                                        <div className="my-2">
                                            <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Title', dispatch, t)}</label>
                                            <input
                                                type="text"
                                                name="EventName"
                                                className="form-control fs-7 fw-normal"
                                                value={eventName}
                                                onChange={(e) => setEventName(e.target.value)}
                                            />
                                        </div>
                                        <div className="my-4">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {getValueFromResource('Schedule', dispatch, t)}{" "}
                                                <span className="fw-semibold text-dark">
                                                    ( {getValueFromResource('Duration', dispatch, t)} : {formatDuration(totalTime)} )
                                                </span>
                                            </label>
                                            <div className="row g-2 align-items-center">
                                                <div className="col-md-3 position-relative" style={showTimexone ? {} : { width: '23%' }}>
                                                    <DatePicker
                                                        selected={eventDate}
                                                        onChange={handleStartDateChange}
                                                        calendarStartDay={calendarStartDay}
                                                        className="form-control"
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                    />
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray position-absolute top-50 end-0 translate-middle-y me-2"></i>
                                                </div>

                                                <div className="col-md-3" style={showTimexone ? {} : { width: '23%' }}>
                                                    <input
                                                        type="time"
                                                        name="startTime"
                                                        value={startTime}
                                                        onChange={handleStartTimeChange}
                                                        className="form-control text-center range-time"
                                                        style={{ height: '43px' }}
                                                    />
                                                </div>
                                                {!showTimexone && (
                                                    <div className="col-auto d-flex align-items-center justify-content-center">
                                                        <span className="text-muted fw-bold">To</span>
                                                    </div>
                                                )}
                                                {showTimexone ? (
                                                    <>
                                                        {/* <div className={`col-md-6 position-relative d-flex align-items-center`}> */}
                                                        <div className={`col-md-6`}>
                                                            <div className='row'>
                                                                <div className='col-md-11'>
                                                                    <Select
                                                                        value={timezoneOptions.find((option) => option.value === selectedTimezone)}
                                                                        onChange={(option: any) => setSelectedTimezone(option.value)}
                                                                        // onChange={handleStartTimezoneChange} //timezone
                                                                        options={timezoneOptions}
                                                                        styles={dropDownSelectionStyles}
                                                                        maxMenuHeight={maxMenuHeight}
                                                                        menuPlacement="auto"
                                                                    />
                                                                </div>
                                                                <div className='col-md-1'>
                                                                    <i
                                                                        className="bi bi-globe cursor-pointer text-primary ms-2"
                                                                        data-tooltip-id="tooltip-Internal"
                                                                        data-tooltip-content={getValueFromResource('Time zone', dispatch, t)}
                                                                        onClick={handleShowTimezone}
                                                                        style={{ fontSize: '20px', position: 'absolute', right: '20.5px', paddingTop: '10px' }}
                                                                    ></i>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="col-md-2" style={{ width: '23%' }}>
                                                            <input
                                                                type="time"
                                                                name="endTime"
                                                                value={endTime}
                                                                onChange={handleEndTimeChange}
                                                                className="form-control text-center range-time"
                                                                style={{ height: '43px' }}
                                                            />
                                                        </div>

                                                        <div className="col-md-4 position-relative d-flex align-items-center" style={{ width: '23%' }}>
                                                            <DatePicker
                                                                selected={eventEndDate}
                                                                onChange={(date) => {
                                                                    const newDate = date || new Date();
                                                                    setEventEndDate(newDate);
                                                                    setTotalTime(calculateTotalTime(eventDate, newDate, startTime, endTime));
                                                                }}
                                                                calendarStartDay={calendarStartDay}
                                                                className="form-control"
                                                                dateFormat={CurrentCultureDateFormat.toString()}
                                                            />
                                                            <i className="insideField-Icons ki-outline ki-calendar text-gray position-absolute top-50 end-0 translate-middle-y me-2"></i>

                                                            <i
                                                                className="bi bi-globe cursor-pointer text-primary ms-2"
                                                                data-tooltip-id="tooltip-Internal"
                                                                data-tooltip-content={getValueFromResource('Time zone', dispatch, t)}
                                                                onClick={handleShowTimezone}
                                                                style={{ fontSize: '20px', position: 'absolute', right: '-24px' }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        {showTimexone ? (
                                            <div className="my-4">
                                                <div className="row g-2 align-items-center">
                                                    <div className="col-md-3 position-relative">
                                                        <DatePicker
                                                            selected={eventEndDate}
                                                            onChange={(date) => {
                                                                const newDate = date || new Date();
                                                                setEventEndDate(newDate);
                                                            }}
                                                            calendarStartDay={calendarStartDay}
                                                            className="form-control"
                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                        />
                                                        <i className="insideField-Icons ki-outline ki-calendar text-gray position-absolute top-50 end-0 translate-middle-y me-2"></i>

                                                    </div>
                                                    <div className="col-md-3" style={showTimexone ? {} : { width: '23%' }}>
                                                        <input
                                                            type="time"
                                                            name="endTime"
                                                            value={endTime}
                                                            onChange={handleEndTimeChange}
                                                            className="form-control text-center range-time"
                                                            style={{ height: '43px' }}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className='row'>
                                                            <div className='col-md-11'>
                                                                <Select
                                                                    value={timezoneEndOptions.find((option) => option.value === selectedEndTimezone)}
                                                                    onChange={(option: any) => setSelectedEndTimezone(option.value)}
                                                                    // onChange={handleEndTimezoneChange} //timezone
                                                                    options={timezoneEndOptions}
                                                                    styles={dropDownSelectionStyles}
                                                                    maxMenuHeight={maxMenuHeight}
                                                                    menuPlacement="auto"
                                                                />
                                                            </div>
                                                            <div className="col-md-1"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                        <div className="my-4 col-md-12">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {getValueFromResource('Remind Me Before', dispatch, t)}
                                            </label>
                                            <Select
                                                value={reminderOptions.find((option) => option.value === selectedReminderTime)}
                                                onChange={(option: any) => setSelectedReminderTime(option.value)}
                                                options={reminderOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                                menuPlacement="auto"
                                            />
                                        </div>
                                        <div className="my-4">
                                            <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Details', dispatch, t)}</label>
                                            <textarea
                                                rows={4}
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer  d-flex justify-content-between align-items-center">
                                        <div>
                                            {/* <strong className='fs-4' style={{ paddingLeft: '5px' }}>{totalTime}</strong> */}
                                        </div>
                                        <div className='d-flex gap-2'>
                                            <button className="btn btn-secondary btn-sm" onClick={oncloseModal}>
                                                {getValueFromResource('Close', dispatch, t)}
                                            </button>
                                            <button className="btn btn-primary btn-sm" onClick={handleSubmit}>
                                                {getValueFromResource('Save', dispatch, t)}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <AddTimeEntry oncloseModal={oncloseModal} presetStartTime={presetStartTime} clickedDate={clickedDate} presetEndTime={presetEndTime} />
                            )}

                        </div>
                    </div>
                </div>
            )}
            <ReactTooltip
                id="tooltip-Internal"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 10000
                }}
                place="top"
            />
        </div>
    )
}

export default UpdateInternalEvent
